import React, { useState, createContext, useContext } from "react";

const TabsContext = createContext();

const Tabs = ({ children, defaultActiveTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div className="sui-tabs sui-tabs-overflow sui-tabs-flushed cross-sell-flushed">
        {children}
      </div>
    </TabsContext.Provider>
  );
};

const TabsMenu = ({ children }) => {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  return (
    <div role="tablist" className="sui-tabs-menu cross-sell-wrapper">
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          index,
          active: activeTab === index,
          onClick: () => setActiveTab(index),
        })
      )}
    </div>
  );
};

const Tab = ({ index, active, onClick, children }) => (
  <button
    type="button"
    role="tab"
    className={`sui-tab-item ${active ? "active" : ""}`}
    aria-selected={active}
    onClick={onClick}
  >
    {children}
  </button>
);

const TabsContent = ({ children }) => {
  const { activeTab } = useContext(TabsContext);
  return (
    <div className="sui-tabs-content">
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          active: activeTab === index,
        })
      )}
    </div>
  );
};

const TabPanel = ({ active, children }) => (
  <div className={`sui-tab-content ${active ? "active" : ""}`} hidden={!active}>
    <div className="cross-sell-wrapper">{children}</div>
  </div>
);

export { Tabs, TabsMenu, Tab, TabsContent, TabPanel };
